import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";
import { AxiosPromise } from "axios";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.AUTH_SERVER_PREFIX}/organization`;
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`, 
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    getByWhere: () => `${RESOURCE_ENDPOINT}/getByWhere`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    dropdownAll: () => `${RESOURCE_ENDPOINT}/dropdown-all`,
    getOrganizationTree: () => `${RESOURCE_ENDPOINT}/getOrganizationTree`,
    getParentOrganizationById: (id: any) => `${RESOURCE_ENDPOINT}/getParentOrganizationById/${id}`,
};

export default class OrganizationApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    };

 

    public getOrganizationTree = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getOrganizationTree();
        return HttpService.get(url, params, headers);
    };

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    };

    public getByWhere = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getByWhere();
        return HttpService.get(url, params, headers);
    };

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    };

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    };

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    };

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    };

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    };

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    };

    public dropdownAll = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdownAll();
        return HttpService.get(url, params, headers);
    };


     

    public getParentOrganizationById = (applicationId: any): AxiosPromise<any> => {
        const url = endpoints.getParentOrganizationById(applicationId);
        return HttpService.get(url);
    };
}
